(function () {
  var RESPONSIVE_LIMIT = 1279;

  function isResponsiveSearchWidth() {
    return window.matchMedia && window.matchMedia('(max-width: ' + RESPONSIVE_LIMIT + 'px)').matches;
  }

  function textFrom(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function rebuildSearchResults(root) {
    if (!root) return;

    var panel = root.matches && root.matches('[data-predictive-search]')
      ? root
      : root.querySelector && root.querySelector('[data-predictive-search]');

    if (!panel) return;

    var productLinks = panel.querySelectorAll('a.predictive-search__item--link-with-thumbnail, a.ah-search-result-row');

    productLinks.forEach(function (link) {
      var img = link.querySelector('img.predictive-search__image, img.ah-search-result-image');
      var title = link.querySelector('.predictive-search__item-heading, .ah-search-result-title');
      var price = link.querySelector('.ah-predictive-price, .price, .price-item, .ah-search-result-price');

      var titleText = textFrom(title) || link.getAttribute('aria-label') || link.getAttribute('title') || 'View product';
      var priceText = textFrom(price);
      var imageNode = img ? img.cloneNode(true) : null;

      var content = document.createElement('div');
      content.className = 'ah-search-result-content';

      var titleNode = document.createElement('div');
      titleNode.className = 'ah-search-result-title';
      titleNode.textContent = titleText;
      content.appendChild(titleNode);

      if (priceText) {
        var priceNode = document.createElement('div');
        priceNode.className = 'ah-search-result-price';
        priceNode.textContent = priceText;
        content.appendChild(priceNode);
      }

      link.innerHTML = '';
      link.classList.add('ah-search-result-row');

      if (imageNode) {
        imageNode.className = 'ah-search-result-image';
        link.appendChild(imageNode);
      }

      link.appendChild(content);
    });
  }

  function rebuildAll() {
    document.querySelectorAll('[data-predictive-search]').forEach(rebuildSearchResults);
  }

  function syncBodyClass() {
    var open = !!document.querySelector('.header__search details[open]');
    document.documentElement.classList.toggle('ah-search-is-open', open && isResponsiveSearchWidth());
    document.body && document.body.classList.toggle('ah-search-is-open', open && isResponsiveSearchWidth());
  }

  function runSoon() {
    window.requestAnimationFrame(function () {
      rebuildAll();
      syncBodyClass();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    runSoon();

    document.addEventListener('input', function (event) {
      if (event.target && event.target.matches('.search-modal__form input[type="search"], .search__input')) {
        window.setTimeout(runSoon, 80);
        window.setTimeout(runSoon, 220);
      }
    }, true);

    document.addEventListener('toggle', function (event) {
      if (event.target && event.target.matches('.header__search details')) {
        runSoon();
      }
    }, true);

    window.addEventListener('resize', function () {
      runSoon();
    }, { passive: true });

    var observer = new MutationObserver(function (mutations) {
      var shouldRun = false;

      mutations.forEach(function (mutation) {
        if (mutation.type !== 'childList' && mutation.type !== 'attributes') return;

        if (mutation.target && mutation.target.matches && (
          mutation.target.matches('[data-predictive-search]') ||
          mutation.target.matches('.header__search details') ||
          mutation.target.closest('[data-predictive-search]')
        )) {
          shouldRun = true;
        }

        mutation.addedNodes && mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (
            (node.matches && node.matches('[data-predictive-search], #predictive-search-results, .predictive-search__item--link-with-thumbnail')) ||
            (node.querySelector && node.querySelector('[data-predictive-search], .predictive-search__item--link-with-thumbnail'))
          ) {
            shouldRun = true;
          }
        });
      });

      if (shouldRun) runSoon();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'aria-expanded']
    });
  });
})();
